import { render, staticRenderFns } from "./section-preview.vue?vue&type=template&id=54213844&scoped=true&"
import script from "./section-preview.vue?vue&type=script&lang=js&"
export * from "./section-preview.vue?vue&type=script&lang=js&"
import style0 from "./section-preview.vue?vue&type=style&index=0&id=54213844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54213844",
  null
  
)

export default component.exports